.root {
  margin: 0;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: var(--tuna-palette-text-secondary);
}

.titleText {
  font-size: 16px;
  font-weight: 500;
}
